import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import dayjs from 'dayjs';
import Countdown from "react-countdown";
import { formatDateWithoutTime } from '../../utils/formateDate';
import RankCriteriaTile from './NextRankCriteria';
import moment from 'moment-timezone';

export default function NextRankComponent({ nextRank }) {
    // const deadline = dayjs(nextRank?.resetDate).add(nextRank?.days, "days").startOf("day")
    const deadline = moment.tz(nextRank.resetDate, nextRank.timeZone)
        .add(nextRank.days, 'days')
        .startOf('day');
    const { t } = useTranslation()
    const renderer = ({ days, hours, minutes, seconds }) => (
        <>
            <span>
                <p>
                    <span>
                        {days} Days
                    </span>
                    <span className='ms-2'>
                        {String(hours).padStart(2, '0')}:
                        {String(minutes).padStart(2, '0')}:
                        {String(seconds).padStart(2, '0')}
                    </span>
                </p>
            </span>
        </>
    );

    return (
        <div className='col-md-12'>
            <div className="joinings_viewBox_Promo" style={{
                border: '1px solid #e8e8e8',
                borderRadius: '8px',
                padding: '16px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                height: "300px",
            }}>
                <h5 style={{
                    marginBottom: '16px',
                    fontWeight: '600'
                }}>
                    {t("Rank Advancement")}
                </h5>
                <div className="joinings_viewBox_head">
                    <Row style={{ width: "inherit" }}>
                        <Col className='text-center promo-tile' md={3} xs={12} style={{
                            padding: '8px',
                            borderRight: '1px solid #e8e8e8'
                        }}>
                            <p>Current Rank</p>
                            {(nextRank.currentRank) ?
                                <>
                                    <div>
                                        <div className="next-ranking-icon">
                                            <img src={nextRank.currentRank.image ?? "/images/ranking-icon.png"} alt="" onError={(e) => e.target.src = "/images/ranking-icon.png"} />
                                            <p>{nextRank.currentRank.name}</p>
                                        </div>

                                    </div>
                                </>
                                :
                                <>
                                    <div className="no-rank-message">
                                        <img src="/images/nodata-image.png" alt="No Rank" />
                                        <p>No Rank Achieved</p>
                                    </div>
                                </>
                            }
                            {nextRank?.acheivedDate && <p>{`Achieved Date : ${formatDateWithoutTime(nextRank?.acheivedDate)}`}</p>}
                        </Col>
                        <Col md={6} xs={12} className='text-center promo-tile' style={{
                            padding: '8px',
                            borderRight: '1px solid #e8e8e8'
                        }}>
                            <p>Advancement Criteria</p>
                            {nextRank?.criteriaDetails?.length > 0 ?
                                <RankCriteriaTile nextRank={nextRank} t={t} /> :
                                <div className="no-criteria-message">
                                    <img src="/images/nodata-image.png" alt="No Criteria" />
                                    <p>No Criteria Available</p>
                                </div>
                            }
                        </Col>
                        <Col md={3} xs={12} className='text-center' style={{
                            padding: '8px',
                            // borderRight: '1px solid #e8e8e8'
                        }}>
                            <p>Next Rank</p>
                            {(nextRank.rank) ?
                                <div>
                                    <div className="next-ranking-icon">
                                        <img src={nextRank.rank.image ?? "/images/ranking-icon.png"} alt="" onError={(e) => e.target.src = "/images/ranking-icon.png"} />
                                        <p>{nextRank.rank.name}</p>
                                    </div>

                                </div>
                                :
                                <div className="no-rank-message">
                                    <img src="/images/nodata-image.png" alt="Max Rank" />
                                    <p>Max Rank Achieved</p>
                                </div>
                            }
                            {(nextRank?.acheivedDate && nextRank?.rank) && <Countdown date={deadline} renderer={renderer} />}

                        </Col>


                    </Row>
                </div>
            </div>
        </div>
    );
}